export enum ErrorContext {
    BUSINESS = 'business',
    MAX_TOKENS = 'maxTokens',
    MSIE = 'msie',
    INCOMPATIBLE_BROWSER = 'incompatibleBrowser',
    DEFAULT = 'default'
}

export const hasAction = new Map<ErrorContext, boolean>([
    [ErrorContext.BUSINESS, true],
    [ErrorContext.MAX_TOKENS, false],
    [ErrorContext.MSIE, true],
    [ErrorContext.INCOMPATIBLE_BROWSER, true],
    [ErrorContext.DEFAULT, false]
]);
